export const fillablePermissions = [
    {id: 72, display_name: 'Ver Usuarios'},
    {id: 74, display_name: 'Ver Auxiliares'},
    {id: 75, display_name: 'Ver Instalaciones'},
    {id: 76, display_name: 'Ver Informes'},
]

export const fillablePermissionsVHE = [
    {id: 62, display_name: 'Ver Usuarios'},
    {id: 64, display_name: 'Ver Auxiliares'},
    {id: 65, display_name: 'Ver Instalaciones'},
    {id: 66, display_name: 'Ver Informes'},
]